
import global from '../../../static/js/global'
import loadPage from '../../components/loadingPage'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

export default {
data() {
return {
pkCode:'',//车位编号
pkRegion:'',//区域
pkArea:'',//面积
pkFloor:'',//楼层
pkOwner:'',//权属类型
pkUsed:'',//使用性质
iconType: "",
title: "我的车位",
nums:'1',
show_1:false,
phone:"",
comnCode:'',
hies:false,
carId:'',
index:'',
phone:'',
show_3:true,
showprompt:false,
prompt:'',
openid:'',
pkDate:''
};
},
components: {
XHeader,
XTable,
Alert,
Flexbox,
FlexboxItem,
XInput,
Group,
loadPage,
XButton
},
beforeMount(){
this.show_1 = true;
if(this.$router.history.current.path == "/myCarInfoList"){
document.title = "我的车位";
}
this.phone=this.$router.history.current.query.phone;
this.pkCode=this.$router.history.current.query.pkCode;
this.carId=this.$router.history.current.query.carId;
this.pkId=this.$router.history.current.query.pkId;
this.comnCode=this.$router.history.current.query.comnCode;
let url1=global.host + 'parkinginfo/getByPkId?comnCode='+ this.comnCode+'&pkId='+this.pkId;
this.$http.get(url1).then(function(res){
if(res.body.result.length==0){
this.showprompt = true;
this.prompt = "暂无数据！";
}
console.log(res.body.result);
console.log('#########');
let parkObj = res.body.result;
this.pkArea = parkObj.pkArea+'㎡';
this.pkFloor = parkObj.pkFloor;
if(parkObj.pkUsed==='1'){
this.pkUsed = "购买";
}else if(parkObj.pkUsed==='2'){
this.pkUsed = "租赁";
}else{
this.pkUsed = parkObj.pkUsed;
}
this.pkRegion = parkObj.pkRegion;
this.pkDate = parkObj.endDate;
if(parkObj.pkOwner==='1'){
this.pkOwner="公共车位"
}else if(parkObj.pkOwner==='2'){
this.pkOwner="产权车位"
}else if(parkObj.pkOwner==='3'){
this.pkOwner="人防车位"
}else{
this.pkOwner=parkObj.pkOwner;
}
this.show_1 = false;
},
function(err){
console.log(err)
})
},
methods:{

}
};



// WEBPACK FOOTER //
// ./src/components/carRentComponents/myCarInfoList.vue